import { CIcon } from '~/icons/types'
export const ciSparkles: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'm22 10.999-2.8-.8c-1.2-.3-2.1-1.2-2.4-2.4l-.8-2.8c-.1-.4-.5-.7-1-.7s-.8.2-1 .7l-.8 2.8c-.3 1.2-1.2 2.1-2.4 2.4l-2.8.8c-.4.1-.7.5-.7 1 0 .4.3.8.7 1l2.8.8c1.2.3 2.1 1.2 2.4 2.4l.8 2.8c.1.4.5.7 1 .7s.8-.3 1-.7l.8-2.8c.3-1.2 1.2-2.1 2.4-2.4l2.8-.8c.4-.1.7-.5.7-1 .1-.4-.2-.8-.7-1Zm-7 4.2c-.6-1.5-1.7-2.6-3.2-3.2 1.5-.6 2.6-1.7 3.2-3.2.6 1.5 1.7 2.6 3.2 3.2-1.5.6-2.6 1.7-3.2 3.2ZM4.8 9l.2 1c.1.4.5.8 1 .8s.9-.3 1-.8l.3-1c.1-.9.8-1.6 1.7-1.8l1-.2c.4-.1.8-.5.8-1s-.4-.9-.8-1l-1-.2c-.9-.2-1.6-.9-1.8-1.8L7 2c-.1-.4-.5-.8-1-.8s-.9.4-1 .8l-.2 1c-.2.9-.9 1.6-1.8 1.8L2 5c-.4.1-.8.5-.8 1s.4.9.8 1l1 .3c.9.1 1.6.8 1.8 1.7ZM6 5c.3.4.6.7 1 1-.4.3-.7.6-1 1-.3-.4-.6-.7-1-1 .4-.3.7-.6 1-1ZM10.8 17.8l-1.2-.4c-.3-.1-.6-.4-.8-.8l-.4-1.2c-.1-.4-.5-.7-.9-.7s-.8.3-.9.7l-.4 1.2c-.2.4-.5.7-.8.8l-1.2.4c-.4.1-.7.5-.7.9s.3.8.7.9l1.2.4c.4.1.7.4.8.8l.4 1.2c.1.4.5.7.9.7s.8-.3.9-.7l.4-1.2c.1-.4.4-.7.8-.8l1.2-.4c.4-.1.7-.5.7-.9s-.3-.8-.7-.9Zm-3.3 1.4c-.1-.2-.3-.3-.5-.5.2-.1.3-.3.5-.5.1.2.3.3.5.5l-.5.5Z'
    }
  ],
  name: 'sparkles',
  type: 'regular'
}
